import { render, staticRenderFns } from "./Shape.vue?vue&type=template&id=b9ee9bf0"
import script from "./Shape.vue?vue&type=script&lang=js"
export * from "./Shape.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports